import { hasAppAccess } from '@/stores/userActions';
import { AppPreferenceItem } from './appPreference';
import { getUserCountry } from './user.helper';
import { differenceInDays } from 'date-fns';

const isGiftOfGivingProgramExpired = (program) => {
  if (!program?.endDate) return true;
  return differenceInDays(new Date(program.endDate), new Date()) < 0;
};

const hasValidGiftOfGivingAccess = (user) => {
  const gift = user?.giftOfGiving;
  if (
    !hasAppAccess(AppPreferenceItem.GiftOfGiving) ||
    !gift ||
    isGiftOfGivingProgramExpired(gift.program)
  ) {
    return false;
  }

  const balance = (gift.allocatedAmount || 0) - (gift.usedAmount || 0);
  return balance > 0;
};

const isForeignUserToNonProfit = (user, nonProfit) => {
  const userCountry = getUserCountry(user);
  return user?.id > 0 && nonProfit?.country !== userCountry;
};

const nonProfitLacksFCRA = (nonProfit) => {
  const certifications = nonProfit.certifications || [];
  const hasFCRA = certifications.some((cert) => cert.name === 'FCRA');

  return !hasFCRA;
};

const doesIndianNonProfitLackFCRA = (nonProfit) => {
  if (!nonProfit || nonProfit.country !== 'IN') return false;

  return nonProfitLacksFCRA(nonProfit);
};

const isDonateDisabled = (user, nonProfit) => {
  if (!nonProfit || !nonProfit.canReceiveDonations) {
    return true;
  }

  const lacksDonationOptions = !nonProfit.stripe_id && !nonProfit?.donation_url;

  const cannotDonate =
    lacksDonationOptions && !hasValidGiftOfGivingAccess(user);

  const isGeoBlocked =
    isForeignUserToNonProfit(user, nonProfit) &&
    doesIndianNonProfitLackFCRA(nonProfit);

  return isGeoBlocked || cannotDonate;
};

const isContributionPending = (post) => {
  return post?.sourcePostData?.contributionStatus === 'pending';
};

const hasValidContributionMethod = (fundraisingOrg, post) => {
  const stripeId = fundraisingOrg?.stripeId;
  const contributionUrl = post?.sourcePostData?.contributionUrl;
  return Boolean(stripeId || contributionUrl);
};

const isContributeDisabled = (fundraisingOrg, post) => {
  if (!fundraisingOrg) return true;

  const noValidMethod = !hasValidContributionMethod(fundraisingOrg, post);
  const pending = isContributionPending(post);

  return noValidMethod || pending;
};

export {
  isGiftOfGivingProgramExpired,
  hasValidGiftOfGivingAccess,
  isForeignUserToNonProfit,
  nonProfitLacksFCRA,
  isDonateDisabled,
  isContributionPending,
  hasValidContributionMethod,
  isContributeDisabled,
};
